import React from 'react'

import moment from 'moment'
import { GetRecordData } from '../Api'
import Config from './../Config'
const { Pushgtagpiwikurl, Pushgtagdata, platform } = Config()
const PageSize = 10
const MaxInterval = 90;
const MaxRange = 6;

export default class RecordCom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentPaginationIndex: 1, // web only


            questionTypesIndex: platform == 'Web' ? 0 : 0,
            ProgressStatusIndex: platform == 'Web' ? 0 : 0,


            dateFrom: moment(new Date()).subtract(6, 'days'),
            dateTo: moment(new Date()).subtract(0, 'days'),
            recordData: [],

            currentRecordIndex: -999
        }
    }

    async componentDidMount() {
        this.onFilter({
            isSearch: true
        })
    }


    async onFilter({ isSearch = false, ProgressStatusIndex = this.state.ProgressStatusIndex, questionTypesIndex = this.state.questionTypesIndex }) {
        this.setState({
            ProgressStatusIndex,
            questionTypesIndex
        })
        if (isSearch && platform == "Mobile") {
            Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
            Pushgtagdata('HelpCenter', 'Filter Feedback', 'HelpCenter_Record_C_Filter', false,
                [
                    {
                        customVariableKey: "HelpCenter_Record_C_Filter",
                        customVariableValue: `${this.props?.ProgressStatus[ProgressStatusIndex]?.text},${this.props?.questionTypes[questionTypesIndex]?.questionType}`
                    }
                ]
            )
        }
        if (!Config()?.isUserLogin) return
        if (isSearch) {
            this.setState({
                recordData: []
            })
            let { dateFrom, dateTo } = this.state
            if (!(questionTypesIndex >= 0 && ProgressStatusIndex >= 0)) return
            let recordData = await GetRecordData({
                dateFrom: moment(dateFrom).format('YYYY-MM-DDT00:00:00'),
                dateTo: moment(dateTo).format('YYYY-MM-DDT23:59:59'),
                status: this.props?.ProgressStatus[ProgressStatusIndex]?.status,
                category: this.props?.questionTypes[questionTypesIndex]?.questionTypeID
            })

            this.setState({
                recordData
            })
        }
    }


    changeDate({ dateFrom = this.state.dateFrom, dateTo = this.state.dateTo, isSearch = false }) {
        if (isSearch) {
            Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
            Pushgtagdata('HelpCenter', 'Filter Feedback Date', 'HelpCenter_Record_C_Date')
        }

        this.setState({
            dateFrom: moment(dateFrom),
            dateTo: moment(dateTo),
        }, () => {
            this.onFilter({
                isSearch
            })
        })
    }

    changePaginationIndex(currentPaginationIndex) {// only web
        if (currentPaginationIndex == this.state.currentPaginationIndex) return
        this.setState({
            currentPaginationIndex
        }, () => {
            this.changeRecordIndex(-9999)
        })
    }

    changeRecordIndex(currentRecordIndex) {
        this.setState({
            currentRecordIndex
        })
    }


    render() {
        const { Content } = this.props

        let { dateFrom, dateTo, recordData, questionTypesIndex, ProgressStatusIndex, currentPaginationIndex, currentRecordIndex } = this.state

        return <>
            <Content
                dateTo={dateTo}
                dateFrom={dateFrom}
                recordData={recordData.slice(PageSize * (currentPaginationIndex - 1), PageSize * (currentPaginationIndex - 1) + PageSize)}
                questionTypesIndex={questionTypesIndex}
                ProgressStatusIndex={ProgressStatusIndex}

                changeDate={this.changeDate.bind(this)}
                onFilter={this.onFilter.bind(this)}


                totalPaginationNum={Math.ceil(recordData.length / PageSize)}
                currentPaginationIndex={currentPaginationIndex}

                currentRecordIndex={currentRecordIndex}
                changeRecordIndex={this.changeRecordIndex.bind(this)}


                MaxInterval={MaxInterval}
                MaxRange={MaxRange}
                changePaginationIndex={this.changePaginationIndex.bind(this)}
            ></Content>
        </>
    }
}